var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.isActive
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Create Mailbox ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-form",
              {
                staticClass: "pt-2",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                    return _vm.create($event)
                  }
                }
              },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("gg-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            label: "Domain",
                            placeholder: "Select a domain",
                            items: _vm.domainOptions,
                            loading: _vm.domainsLoading,
                            disabled: _vm.domainsLoading,
                            "no-data-text":
                              "No domains are available on your hosting plans.",
                            "data-vv-name": "domain",
                            "data-vv-as": "Domain",
                            "error-messages": _vm.errors.collect("domain")
                          },
                          model: {
                            value: _vm.domainKey,
                            callback: function callback($$v) {
                              _vm.domainKey = $$v
                            },
                            expression: "domainKey"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("gg-text-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            outlined: "",
                            dense: "",
                            label: "Mailbox Name",
                            placeholder: "ex. yourname",
                            autocomplete: "new-password",
                            name: "Mailbox",
                            "error-messages": _vm.errors.collect("Mailbox")
                          },
                          model: {
                            value: _vm.model.email,
                            callback: function callback($$v) {
                              _vm.$set(_vm.model, "email", $$v)
                            },
                            expression: "model.email"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("gg-input-label", [_vm._v("Password")]),
                        _c("compact-password", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            outlined: "",
                            autocomplete: "new-password",
                            "with-generator": "",
                            "data-vv-name": "password",
                            "data-vv-as": "Password",
                            "error-messages": _vm.errors.collect("password")
                          },
                          model: {
                            value: _vm.model.password,
                            callback: function callback($$v) {
                              _vm.$set(_vm.model, "password", $$v)
                            },
                            expression: "model.password"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("v-switch", {
                          staticClass: "mt-0",
                          attrs: {
                            color: "green",
                            label:
                              "Send welcome email with mail client configuration instructions."
                          },
                          model: {
                            value: _vm.sendSettings,
                            callback: function callback($$v) {
                              _vm.sendSettings = $$v
                            },
                            expression: "sendSettings"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.address
                      ? _c(
                          "v-col",
                          {
                            staticClass: "pt-0",
                            attrs: {
                              cols: "12"
                            }
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "body-2 mb-0"
                              },
                              [
                                _vm._v("This will create "),
                                _c("strong", [_vm._v(_vm._s(_vm.address))]),
                                _vm._v(".")
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c("v-spacer"),
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading,
                  disabled: _vm.domainsLoading
                },
                on: {
                  click: _vm.create
                }
              },
              [_vm._v(" Create Mailbox ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }